import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemContent, ItemTitle } from '../DarkWebStyles';
import { DataItem, DataItemText, DeleteIcon } from '../DarkWebModal/DarkWebModalStyles';
import { deleteTelephone } from '../../../../ExperianActions';
import StopMonitoringModal from '../StopMonitoringModal/StopMonitoringModal';
import ExperianContext from '../../../../ExperianContext';

const TelephoneNumbers = ({ title, data }) => {
  const [telephoneToDelete, setTelephoneToDelete] = useState(null);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  const onConfirmCallback = useCallback(async () => {
    await dispatch(deleteTelephone(clientId, subscriberId, telephoneToDelete.Label));
    setTelephoneToDelete(null);
  }, [clientId, subscriberId, telephoneToDelete, dispatch]);

  return (
    data &&
    data.length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <ItemContent>
            {data.map(telephone => (
              <DataItem key={telephone.Number}>
                <DeleteIcon onClick={() => setTelephoneToDelete(telephone)} />
                <DataItemText>{telephone.Number}</DataItemText>
              </DataItem>
            ))}
          </ItemContent>
        </div>
        {!!telephoneToDelete && (
          <StopMonitoringModal
            onConfirm={onConfirmCallback}
            onRequestClose={() => setTelephoneToDelete(null)}
          >
            Are you sure you want to stop monitoring:
            <br />
            Telephone {telephoneToDelete.Number}?
          </StopMonitoringModal>
        )}
      </>
    )
  );
};

export default TelephoneNumbers;
